export const TrustCapacityEnum = {
  Trustee: 'TRUSTEE',
} as const satisfies Record<string, string>;

export const TrustCapacityLabels = {
  [TrustCapacityEnum.Trustee]: 'Trustee',
} as const;

export type TrustCapacity =
  (typeof TrustCapacityEnum)[keyof typeof TrustCapacityEnum];
